import { render, staticRenderFns } from "./CommInfo.vue?vue&type=template&id=9d1a1264&scoped=true"
import script from "./CommInfo.vue?vue&type=script&lang=js"
export * from "./CommInfo.vue?vue&type=script&lang=js"
import style0 from "./CommInfo.vue?vue&type=style&index=0&id=9d1a1264&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9d1a1264",
  null
  
)

export default component.exports